import { render, staticRenderFns } from "./ListGoldOrderCompleted.vue?vue&type=template&id=3f36171e"
import script from "./ListGoldOrderCompleted.vue?vue&type=script&lang=js"
export * from "./ListGoldOrderCompleted.vue?vue&type=script&lang=js"
import style0 from "./ListGoldOrderCompleted.vue?vue&type=style&index=0&id=3f36171e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports